import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import { Toaster } from './components/ui/sonner';
import PWAInstall from './components/PWAInstall';
import NotificationBanner from './components/NotificationBanner';
import Login from './pages/auth/Login';
import Register from './pages/auth/Register';
import ForgotPassword from './pages/auth/ForgotPassword';
import ResetPassword from './pages/auth/ResetPassword';
import Layout from './components/Layout';
import Home from './pages/Home';
import Dashboard from './pages/Dashboard';
import ProposalForm from './pages/proposals/ProposalForm';
import ProposalView from './pages/proposals/ProposalView';
import PublicProposal from './pages/proposals/PublicProposal';
import Clients from './pages/Clients';
import Agenda from './pages/Agenda';
import Whatsapp from './pages/Whatsapp';
import Temas from './pages/Temas';
import Products from './pages/Products';
import Services from './pages/Services';
import Receivables from './pages/Receivables';
import Despesas from './pages/financeiro/Despesas';
import FluxoCaixa from './pages/financeiro/FluxoCaixa';
import Reports from './pages/Reports';
import Settings from './pages/Settings';
import Admin from './pages/admin/Admin';
import Subscribe from './pages/Subscribe';
import Employees from './pages/Employees';
import Suggestions from './pages/Suggestions';
import EmployeePortal from './pages/EmployeePortal';
import EmployeeProposalForm from './pages/EmployeeProposalForm';
import PaymentSuccess from './pages/PaymentSuccess';
import './App.css';

const ProtectedRoute = ({ children, adminOnly = false }) => {
  const { user, loading } = useAuth();
  if (loading) return (
    <div className="min-h-screen bg-background flex items-center justify-center">
      <div className="w-8 h-8 border-2 border-orange-500 border-t-transparent rounded-full animate-spin" />
    </div>
  );
  if (!user) return <Navigate to="/login" replace />;
  if (adminOnly && !user.is_admin) return <Navigate to="/" replace />;
  return children;
};

function AppContent() {
  const { user } = useAuth();
  return (
    <>
      {user && !user.is_admin && <NotificationBanner />}
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/p/:id" element={<PublicProposal />} />
        <Route path="/pagto_ok" element={<PaymentSuccess />} />
        <Route path="/portal/:companyId" element={<EmployeePortal />} />
        <Route path="/portal/:companyId/proposals/new" element={<EmployeeProposalForm />} />
        <Route path="/portal/:companyId/proposals/:proposalId/edit" element={<EmployeeProposalForm />} />
        <Route path="/" element={<ProtectedRoute><Layout /></ProtectedRoute>}>
          <Route index element={<Home />} />
          <Route path="dashboard" element={<Dashboard />} />
          <Route path="proposals/new" element={<ProposalForm />} />
          <Route path="proposals/:id/edit" element={<ProposalForm />} />
          <Route path="proposals/:id" element={<ProposalView />} />
          <Route path="clients" element={<Clients />} />
          <Route path="agenda" element={<Agenda />} />
          <Route path="whatsapp" element={<Whatsapp />} />
          <Route path="temas" element={<Temas />} />
          <Route path="products" element={<Products />} />
          <Route path="services" element={<Services />} />
          <Route path="receivables" element={<Receivables />} />
          <Route path="financeiro/despesas" element={<Despesas />} />
          <Route path="financeiro/caixa" element={<FluxoCaixa />} />
          <Route path="reports" element={<Reports />} />
          <Route path="settings" element={<Settings />} />
          <Route path="subscribe" element={<Subscribe />} />
          <Route path="employees" element={<Employees />} />
          <Route path="suggestions" element={<Suggestions />} />
          <Route path="admin" element={<ProtectedRoute adminOnly><Admin /></ProtectedRoute>} />
        </Route>
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Toaster position="top-right" theme="dark" richColors />
        <PWAInstall />
        <AppContent />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
